import React from 'react';
import Skeleton from 'react-loading-skeleton';

const LoadingReviewOrder = () => {
    return (
        <div className="order order--p2">
            <div className="product__item">
                <div className="product__thumbnail">
                    <Skeleton width="120px" height="120px" />
                </div>
                <div className="product__detail">
                    <div className="product__detail--header">
                        <div className="product__price">
                            <Skeleton width="200px" height="30px" />
                        </div>
                        <div className="product__name">
                            <Skeleton height="30px" width="200px" />
                        </div>
                    </div>
                    <Skeleton height="30px" width="200px" />
                </div>
            </div>
            <div className="review__form">
                <div className="review__form--loading">
                    <Skeleton height="90px" count={3} />
                </div>
                <Skeleton height="110px" style={{ marginBottom: '15px' }} />
                <Skeleton height="30px" />
            </div>
        </div>
    );
};

export default LoadingReviewOrder;
